export enum PreviousPeriodBarColorsEnum {
    USE_BAR = 'USE_BAR',
    CUSTOM = 'CUSTOM'
};
